import { Text } from "@react-three/drei";
import { useMemo } from "react";
import { Float } from "@react-three/drei";
import { floatingTextData2D } from "../model_data/floatingtext_data";

const TextIntro = () => {
    // Create floating text elements
    const floatingTexts = useMemo(
        () =>
        floatingTextData2D.map((data, index) => (
            <Float
                key={`float-text-${index}`}
                position={data.position}
                rotation={data.rotation}
                speed={2.5}
                rotationIntensity={0.1}
                floatIntensity={0.6}
            >
                <Text
                    color={data.color}
                    fontSize={data.fontSize}
                    anchorX="center"
                    anchorY="middle"
                    outlineWidth={0.02}
                    outlineColor="black"
                >
                    {data.text}
                </Text>
            </Float>
        )),
        []
    );

    return (
        <>
            {floatingTexts}
        </>
    )
}

export default TextIntro;